import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router';
import { TextV2 } from '@insights-ltd/design-library/components';
import { SxProps } from '@mui/material';

type BreadcrumbsProps = {
  crumbs: { [key: string]: string };
  activeText: string;
  sx?: SxProps;
};

const Breadcrumbs = ({ crumbs, activeText, sx }: BreadcrumbsProps) => (
  <MuiBreadcrumbs sx={sx} aria-label="breadcrumb">
    {Object.entries(crumbs).map(([to, text]) => (
      <TextV2 key={to} variant="bodySmall" component="span">
        <Link
          component={RouterLink}
          to={to}
          sx={{
            display: 'block',
          }}
        >
          {text}
        </Link>
      </TextV2>
    ))}
    <TextV2 variant="bodySmall" component="p" color="textPrimary">
      {activeText}
    </TextV2>
  </MuiBreadcrumbs>
);

export default Breadcrumbs;
